export const underscoreToSentence = (str: string) => {
  const words = str.split("_");
  if (words.length <= 1) {
    return str;
  }

  const [firstWord, ...rest] = words;

  if (!firstWord.length) return str;

  return [firstWord[0].toUpperCase() + firstWord.slice(1), ...rest].join(" ");
};
